
module dg.navigation {

    class NavIconController{

        public iconClass: string;
        public stateName: string;

        $onChanges = (changes) => {
            if (changes.stateName && changes.stateName.currentValue) {
                this.iconClass = this.stateName.toLocaleLowerCase().replace('\.', '-');
            }

            //if (changes.iconClass.currentValue) {
            //    this.iconClass = this.stateName.toLocaleLowerCase().replace('\.', '-');
            //}
        };
    }

    angular.module('dg.navigation').component('navIcon', {
        bindings: {
            stateName: '<?',
            iconClass: '@?'
        },
        controller: NavIconController,
        template: '<i class="app-icon" ng-class="$ctrl.iconClass"></i>'
    });  
}